__webpack_require__.p = "{{PUBLIC_PATH_WIDGETS}}";